import { combineReducers } from 'redux';

import flexbids from './flexbids/reducers';

export default combineReducers({ flexbids });
